module.exports = __webpack_public_path__ + "static/media/Sample_data_xlsx.a22f516c.xlsx";